import { render, staticRenderFns } from "./TrashUserHistorical.vue?vue&type=template&id=54930293&scoped=true&"
import script from "./TrashUserHistorical.vue?vue&type=script&lang=js&"
export * from "./TrashUserHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54930293",
  null
  
)

export default component.exports